import { ActionButton, Text, DefaultButton, Dialog, DialogFooter, DialogType, Label, MessageBarType, PrimaryButton, Stack, Link } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { EventScheduleDetail } from '../EventScheduleDetail/EventScheduleDetail';
import { EventSchedulesListView } from './EventSchedulesListView';
import { AddUpdateEventSchedule } from '../AddUpdateEventShedule/AddUpdateEventShedule';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventScheduleList } from '../../../../../Models/Event/IIEventScheduleList';
import { getSemesterNumber } from '../../../../../Tools/DateTime';
import { IAppStore } from '../../../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';

interface IEventSchedulesListProps {
    eventId: number;
    numberOfLessons?: number;
    lessonLength?: number;
    profile: IUserProfile;
}


export const EventSchedulesList: React.FunctionComponent<IEventSchedulesListProps> = (props) => {
    const [isShedulerAddOpen, setIsShedulerAddOpen] = useBoolean(false);
    const [isShedulerDetailOpen, setIsShedulerDetailOpen] = useBoolean(false);

    const [eventSchedule, setEventSchedule] = React.useState<IEventScheduleList>();
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [eventScheduleList, setEventScheduleList] = React.useState<IEventScheduleList[]>([]);
    const [eventScheduleListFiltered, setEventScheduleListFiltered] = React.useState<IEventScheduleList[]>([]);
    const [isDeleteLessonOpened, setIsDeleteLessonOpened] = useBoolean(false);
    const [actualSemester, setActualSemester] = React.useState(1);

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
        const result = await schedulesApi.getEventSchedules(props.eventId);
        if (result.isSuccess && result.data) {
            setEventScheduleList(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
        setActualSemester(getSemesterNumber(new Date(Date.now())));
    }, [])


    React.useEffect(() => {
        const l = eventScheduleList.filter(x => getSemesterNumber(x.date) === actualSemester);
        setEventScheduleListFiltered(l);
    }, [actualSemester, eventScheduleList])

    const AddLesson = () => {
        setEventSchedule({
            eventId: props.eventId,
            date: new Date(Date.now()),
            description: "",
            id: 0,
            dateString: "",
            key:""
        });
        setIsShedulerAddOpen.setTrue();
    }

    const EditLesson = () => {
        setIsShedulerAddOpen.setTrue();
    }


    const openDeleteLessonDialog = async (lesson: IEventScheduleList) => {
        setEventSchedule(lesson);
        setIsDeleteLessonOpened.setTrue();
    }

    const deleteLesson = async () => {
        if (eventSchedule) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
            const result = await schedulesApi.removeEventSchedule(eventSchedule.eventId, eventSchedule.id);
            if (result.isSuccess && result.data) {
                setIsDeleteLessonOpened.setFalse();
                setEventSchedule(undefined);
                loadData();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsDeleteLessonOpened.setFalse();
            setIsLoading.setFalse();
        }
    }

    const openLesson = (item: IEventScheduleList) => {
        setEventSchedule(item);
        setIsShedulerDetailOpen.setTrue();
    }

    return (<Stack styles={{ root: { paddingTop: 15 } }}>
        {props.numberOfLessons ?
            <Stack styles={{ root: { paddingLeft: 10} }} horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
                <Label>Počet lekcí / pololetí </Label>
                <Text>{props.numberOfLessons} x {props.lessonLength} min.</Text>
            </Stack> : null}
        <Stack styles={{ root: { paddingLeft: 10, paddingBottom: 15 } }} horizontal tokens={{ childrenGap: 5 }} >
            <Label>Odučeno</Label><Label>{eventScheduleListFiltered.length} {eventScheduleListFiltered.length > 0 && eventScheduleListFiltered.length < 5 ? "lekce" : "lekcí"} v</Label> <Link onClick={() => { setActualSemester(actualSemester === 1 ? 2 : 1) }}>{actualSemester} pololetí</Link>
        </Stack>
        <Stack horizontal>
            <ActionButton iconProps={{ iconName: "Add" }} onClick={AddLesson}>Přidat lekci</ActionButton>
            <ActionButton disabled={eventSchedule === undefined} iconProps={{ iconName: "Edit" }} onClick={EditLesson}>Editovat lekci</ActionButton>
        </Stack>
        <EventSchedulesListView
            isAdmin={props.profile.isAdmin}
            deleteLesson={openDeleteLessonDialog}
            openLesson={openLesson}
            selectLesson={setEventSchedule} items={eventScheduleListFiltered} isLoading={isLoading} statusMessage={statusMessage} />
        {isShedulerAddOpen ? <AddUpdateEventSchedule refresh={loadData}
            eventSchedule={eventSchedule}
            isOpened={isShedulerAddOpen}
            onDismiss={setIsShedulerAddOpen.setFalse}
        /> : null}
        {eventSchedule && isShedulerDetailOpen ? <EventScheduleDetail eventId={eventSchedule?.eventId} id={eventSchedule?.id} isOpened={isShedulerDetailOpen} onDismiss={setIsShedulerDetailOpen.setFalse} />
            : null}

        {isDeleteLessonOpened ?
            <Dialog
                hidden={!isDeleteLessonOpened}
                onDismiss={setIsDeleteLessonOpened.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Odstranění lekce",
                    subText: "Opravdu ostranit vybranou lekci"
                }}
                modalProps={{ isBlocking: true }}>
                <DialogFooter>
                    <PrimaryButton onClick={deleteLesson} text="Odstranit" />
                    <DefaultButton onClick={setIsDeleteLessonOpened.setFalse} text="Zavřít" />
                </DialogFooter>
            </Dialog> : null}
    </Stack>)
}

const EventSchedulesListToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const EventSchedulesListDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(EventSchedulesListToProps, EventSchedulesListDispatchToProps)(EventSchedulesList);
